import React, { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";

const Loading = () => (
  <div className="flex justify-center items-center h-screen w-full">
    <div className="animate-spin border-t-2 border-b-2 border-blue-500 rounded-full w-8 h-8"></div>
    <span className="ml-2">Loading...</span>
  </div>
);

const MemberBrowse = lazy(() =>
  import("../../pages/app/member/MemberBrowsePage")
);

const MemberGame = lazy(() => import("../../pages/app/member/MemberGamePage"));

const memberRouter = () => {
  return [
    {
      path: "",
      element: <Navigate to="/app/member/browse" replace />,
    },
    {
      path: "browse",
      element: (
        <Suspense fallback={<Loading />}>
          <MemberBrowse />
        </Suspense>
      ),
    },
    {
      path: "game",
      element: (
        <Suspense fallback={<Loading />}>
          <MemberGame />
        </Suspense>
      ),
    },
  ];
};

export default memberRouter;
